import { createUrl } from "../../components/calendar/calendarUtils";
import { GroupsOptions } from "../../types/groups.types";
import { filterUsersRoles } from "../../utils/filterUsersRoles";

export const schedulesOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["end_date", "group_one", "group_two", "group_thre"],
        fieldTypesToRemove: [],
    },

    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "clinic_id",
                enabled: true,
            },
            {
                field: "technician",
                sort: "user_id.first_name",
                enabled: true,
            },
            {
                field: "user",
                relatedTable: "directus_users",
                displayTemplate: "{{first_name}} {{last_name}}",
                filter: filterUsersRoles,
                enabled: true,
                sort: "first_name",
            },
            {
                field: "services",
                relatedTable: "services",
                displayTemplate: "{{name}}",
                enabled: true,
                sort: "sort_order",
                filter: { sort_order: { _nnull: true } },
            },

            {
                field: "start_date",
                dateFormat: "eeee, dd/MM/yyyy HH:mm",
            },
            {
                field: "room",
                enabled: true,
            },
        ],
        navigateAfterCreate: (params: any) => createUrl(params, "schedules"),
        navigateAfterUpdate: (params: any) => createUrl(params, "schedules"),
    } as GroupsOptions,
};
